<mat-card data-at-all-rooms-modal>
  <mat-card-title>{{
    '+COMMISSIONING.ROOM.ALL_ADDED_ROOMS_MODAL.TITLE' | translate
  }}</mat-card-title>
  <mat-card-content class="flex flex-col gap-[4px]">
    <div *ngFor="let room of rooms; let index = index" class="room-panel">
      <div class="flex flex-row items-center">
        <div class="flex flex-row gap-[5px] justify-start items-center w-full">
          <div data-at-all-rooms-modal-room-name-label class="room-name">
            {{ room?.properties?.name?.value }}
          </div>
        </div>
        <button
          data-at-all-rooms-modal-icon-edit
          mat-icon-button
          gtm="onOpen"
          gtmAction="Edit room modal"
          gtmCategory="allAddedRooms"
          class="edit-btn"
          (click)="onEditRoom(room)"
        >
          <mat-icon>create</mat-icon>
        </button>
        <button
          data-at-all-rooms-modal-icon-delete
          mat-icon-button
          gtm="onOpen"
          gtmAction="Delete room confirmation panel"
          gtmCategory="allAddedRooms"
          class="delete-btn"
          (click)="onDeleteRoomAttempt(room)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-all-rooms-modal-btn-close
      mat-button
      gtm="onCancelDialog"
      gtmCategory="allAddedRooms"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-all-rooms-modal-btn-add-room
      mat-raised-button
      gtm="onOpen"
      gtmAction="Add room dialog"
      gtmCategory="allAddedRooms"
      color="primary"
      [disabled]="installationFeaturesStore.isAddRoomDisabled$ | async"
      (click)="onAddRoom()"
    >
      {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_ROOM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
